import { Stack } from '@fluentui/react';
import { NoDataView } from 'common/components/DataPlaceholders';
import { DocumentList } from 'common/components/DocumentList';
import { getWindowDimensions } from 'common/utils/columnUtilities';
import React from 'react';
import { PaymentDetails_payment_entityDocumentsByEntityId } from '../../../__generated__/PaymentDetails';
import { columns } from 'common/components/ActionMenu/column.data';
import { useStyles } from './index.styles';

interface FilesProps {
  fileListData: PaymentDetails_payment_entityDocumentsByEntityId;
}
export const Files: React.FC<FilesProps> = ({ fileListData }) => {
  const styles = useStyles();

  const { width } = getWindowDimensions();
  const documentViewPosition = width ? width * 0.8 - 500 : 50;

  return (
    <Stack tokens={{ childrenGap: 10 }} className={styles.mainStack}>
      <Stack tokens={{ childrenGap: 10, padding: 10 }}>
        {fileListData?.nodes?.length && (
          <DocumentList
            isNew={false}
            columns={columns}
            data={fileListData.nodes || []}
            paddingLeft={documentViewPosition}
          />
        )}
        <NoDataView
          show={fileListData?.nodes?.length === 0}
          title="No Attachments"
        />
      </Stack>
    </Stack>
  );
};
